import { log } from 'log';
import { useCallback, useMemo } from 'react';

import { ReceivePacketCallback } from '../../../types';

import * as Types from '../types';

export const useRequestCafPacket = ({
    sdk,
    license,
    transactionID,
    onError,
    receivePacket
}: {
    sdk: Types.CAFSdkInstance | null;
    license: any;
    transactionID: string | null;
    onError: CallableFunction;
    receivePacket: ReceivePacketCallback;
}) => {
    const {
        identityJwt,
        trustJwt,
        policy,
        cpf,
        metadata
    } = useMemo(() => Object.fromEntries(license?.map(({
        key,
        value
    }: {
        key: string;
        value: string;
    }) => {
        return [key, value];
    }) ?? []), [license]);

    return useCallback(async () => {
        if (!sdk || !sdk.Sdk) {
            return;
        }

        log('gcReq', {
            transactionID,
            license
        });

        const cafSdk = new sdk.Sdk(
            identityJwt,
            {
                mobileToken: trustJwt,
                throwOnRecall: false,
                faceLivenessSettings: {
                    startButton: {},
                    permissionButton: {}
                },
                enableTimer: true,
                metadata
            });

        try {
            const verificationResult = await cafSdk.verifyPolicy(cpf, policy);

            log('gcInfo', {
                transactionID,
                license,
                message: verificationResult.isAuthorized
            });

            receivePacket(JSON.stringify(verificationResult), transactionID);
        } catch (exception) {
            onError(null, exception);
        }
    }, [
        sdk,
        trustJwt,
        cpf,
        policy,
        identityJwt,
        metadata,
        license,
        transactionID,
        onError,
        receivePacket
    ]);
};
